import { ROUTE_NAME } from '@/config/constants'

import usePerson from '@/hooks/usePerson'
import useStatus from '@/hooks/useStatus'

const {
  isAdminDataComplete,
  isHealthQuestionsComplete,
  isHealthQuestionsCompleteForPerson,
  isPersonDataComplete,
  isPersonalDataCompleteForPerson,
  isPreInsurerCompleteForPerson,
  isWorkSituationCompleteForPerson,
} = useStatus()

const { filterPersonsToValidate } = usePerson()

export const RouteUtil = {
  getFirstInvalidRoute(basket, selectedCategoriesMap, isPersonnelNumberRequired) {
    if (!isPersonDataComplete(basket, selectedCategoriesMap)) {
      const firstInvalidPerson = filterPersonsToValidate(basket).find(p => {
        return (
          !isPersonalDataCompleteForPerson(p.personData) ||
          !isPreInsurerCompleteForPerson({
            immigrant: p.immigrant,
            preInsurer: p.preInsurer,
            kvgContractStartDate: p.kvgContractStartDate,
            isVVGOnly: selectedCategoriesMap[p.personId].isVVGOnly,
          }) ||
          !isWorkSituationCompleteForPerson(p.workSituation, {
            isVVGOnly: selectedCategoriesMap[p.personId].isVVGOnly,
            isKVGOnly: selectedCategoriesMap[p.personId].isKVGOnly,
          })
        )
      })

      return {
        errorKey: 'error.MISSING_PERSON_DATA',
        route: {
          name: basket.existingCustomer
            ? ROUTE_NAME.APPLICATION_EXISTING_CUSTOMER_DATA
            : ROUTE_NAME.APPLICATION_PERSONAL_DATA,
          params: basket.existingCustomer ? null : { personId: firstInvalidPerson.personId },
          query: { jumpToError: true },
        },
      }
    }

    if (!isAdminDataComplete(basket, isPersonnelNumberRequired)) {
      return {
        errorKey: 'error.MISSING_ADMIN_DATA',
        route: {
          name: basket.existingCustomer
            ? ROUTE_NAME.APPLICATION_EXISTING_CUSTOMER_DATA
            : ROUTE_NAME.APPLICATION_ADMIN_DATA,
          query: { jumpToError: true },
        },
      }
    }

    if (!isHealthQuestionsComplete(basket.persons)) {
      const firstInvalidPerson = basket.persons.find(p => {
        // @TODO this might be combined with the isHealthQuestionsComplete function
        return !isHealthQuestionsCompleteForPerson(p.healthQuestionAnswers)
      })

      return {
        errorKey: 'error.MISSING_HEALTH_DATA',
        route: {
          name: ROUTE_NAME.APPLICATION_HEALTHQUESTIONS,
          params: {
            personId: firstInvalidPerson.personId,
          },
          query: {
            jumpToError: true,
            t: Date.now(),
          },
        },
      }
    }
  },

  invalidPersonIdParam(route, persons) {
    if (!route.params?.personId) return false

    const personId = route.params.personId
    const validPersonId = id => persons.find(p => p.personId === id)
    return !personId || !validPersonId(personId)
  },
}
